/* istanbul ignore file */
// This file was generated by figma/utils.mjs
import React, { FunctionComponent } from 'react'

export const CommSmsFill: FunctionComponent = (): JSX.Element => (
  <React.Fragment>
    <path
      d='M3 7C3 6.44771 3.44772 6 4 6H20C20.5523 6 21 6.44772 21 7V17.5892C21 18.1415 20.5523 18.5892 20 18.5892H16.2632V21.8512C16.2632 22.2881 15.7422 22.5149 15.4224 22.2171L11.5263 18.5892H4C3.44772 18.5892 3 18.1415 3 17.5892V7Z'
      fill='currentColor'
    />
  </React.Fragment>
)
